import {JsonObject, JsonProperty} from 'json2typescript';


@JsonObject('Answer')
export class Answer {
    @JsonProperty('question_no',Number)
     questionNo = 0;
    @JsonProperty('choice_no',Number)
     choiceNo = 0;
    @JsonProperty('answer_text',String)
     answer = '';


    /*constructor() {

    }*/
   /* constructor(json:any) {

      this.answer = json.answer;

      this.choiceNo = json.choiceNo;

      this.questionNo = json.questionNo;
    }*/

}
